

// click video count js for forloop
 document.addEventListener("DOMContentLoaded", function () {


//   const videoCards = document.querySelectorAll(".product-video-count-api .videocardapi");

//   videoCards.forEach(function (card) {
//     let clicked = false;
//     card.addEventListener("click", async function () {

//       if (clicked) return; // prevent multiple clicks
//       clicked = true;

//       const websiteName = document.body.getAttribute("data-website");
//       const titleName = this.getAttribute("data-producttitle");

//       console.log("Sending:", websiteName, titleName);

//       // Prepare form data
//       const formData = new FormData();
//       formData.append("website", websiteName);
//       formData.append("title", titleName);

//       try {
//         const response = await fetch("https://digital.agarolifestyle.com/luvlap_api/click_video_count.php", {
//           method: "POST",
//           body: formData
//         });

//         const result = await response.json();
//         // console.log("API Response:", result);

//       } catch (error) {
//         console.error("Error submitting form:", error);
//       }


//     });
//   });





  // video plaing 6 sec
  const videoCardsPlaying = document.querySelectorAll(".product-video-count-api .videocardpopupapi video");

  videoCardsPlaying.forEach(video => {
    // Prevent multiple listeners on the same video
    if (video.dataset.listenerAttached) return;
    video.dataset.listenerAttached = "true";

    video.addEventListener("timeupdate", async function () {
      if (video.currentTime >= 6 && !video.hasLogged) {
        const videoCardsPlayingWebsite = document.body.getAttribute("data-website");
        const parentCard = video.closest(".productVideocardapi");
        const videoCardsPlayingTitleName = parentCard ? parentCard.getAttribute("data-producttitle") : null;
        const videoCardsPlayingSku = parentCard ? parentCard.getAttribute("data-productsku") : null;
        const videoCardsPlayingURL = video.querySelector("source").getAttribute("src");

        // Prepare form data
        const formData = new FormData();
        formData.append("website", videoCardsPlayingWebsite);
        formData.append("title", videoCardsPlayingTitleName);
        formData.append("sku", videoCardsPlayingSku);
        formData.append("url", videoCardsPlayingURL);
         
        console.log("6secDone");

        try {
          const response = await fetch("https://digital.agarolifestyle.com/luvlap_api/playing-video-count.php", {
            method: "POST",
            body: formData
          });
          await response.json();
        } catch (error) {
          console.error("Error submitting form:", error);
        }

        video.hasLogged = true; // Prevent multiple logs
      }
    });
  });






 // 1 sec
  const videoCardsPlayingOnsec = document.querySelectorAll(".product-video-count-api .videocardpopupapi video");

  videoCardsPlayingOnsec.forEach(video => {
    // Prevent multiple listeners on the same video
    if (video.dataset.listenerAttached1Sec) return;
    video.dataset.listenerAttached1Sec = "true";

    video.addEventListener("timeupdate", async function () {
      if (video.currentTime >= 1 && !video.hasLogged1Sec) {
        const videoCardsPlayingWebsite = document.body.getAttribute("data-website");
        const parentCard = video.closest(".productVideocardapi");
        const videoCardsPlayingTitleName = parentCard ? parentCard.getAttribute("data-producttitle") : null;
         const videoCardsPlayingSku = parentCard ? parentCard.getAttribute("data-productsku") : null;
        const videoCardsPlayingURL = video.querySelector("source").getAttribute("src");


        console.log("Sending:", videoCardsPlayingWebsite, videoCardsPlayingTitleName, videoCardsPlayingURL);

        // Prepare form data
        const formData = new FormData();
        formData.append("website", videoCardsPlayingWebsite);
        formData.append("title", videoCardsPlayingTitleName);
         formData.append("sku", videoCardsPlayingSku);
        formData.append("url", videoCardsPlayingURL);

        console.log("1-second API called");

        try {
          const response = await fetch("https://digital.agarolifestyle.com/luvlap_api/click_video_count.php", {
            method: "POST",
            body: formData
          });
          await response.json();
        } catch (error) {
          console.error("Error submitting form:", error);
        }

        video.hasLogged1Sec = true; // Prevent multiple logs
      }
    });
  });








// click video count js for one video
//  document.addEventListener("DOMContentLoaded", function () {
//   const videoCard = document.querySelector(".product-video-count-api .oneProVideocardapi");

//   if (!videoCard) return; // exit if element not found

//   // Prevent multiple listeners
//   if (videoCard.dataset.listenerAttached === "true") return;
//   videoCard.dataset.listenerAttached = "true";

//   let clicked = false;

//   videoCard.addEventListener("click", async function () {
//     if (clicked) return; // prevent multiple clicks
//     clicked = true;

//     const websiteNameOne = document.body.getAttribute("data-website");
//     const titleNameOne = this.getAttribute("data-producttitle");

//     console.log("Sending:", websiteNameOne, titleNameOne);

//     // Prepare form data
//     const formData = new FormData();
//     formData.append("website", websiteNameOne);
//     formData.append("title", titleNameOne);

//     try {
//       const response = await fetch("https://digital.agarolifestyle.com/luvlap_api/click_video_count.php", {
//         method: "POST",
//         body: formData
//       });

//       const result = await response.json();
//       console.log("API Response:", result);

//     } catch (error) {
//       console.error("Error submitting form:", error);
//     }
//   });
// });









// end
});

